<template>
  <span>
    <i :class="iconClass" />
    <span class="sr-only">{{ $t('data_loading.loading') }}</span>
  </span>
</template>

<script>
export default {
  props: {
    iconClassAddition: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // class="fa-spin fa-3x fa-fw"
    iconClass() {
      return ['fa', 'fa-spinner', 'fa-pulse'].concat(this.iconClassAddition)
    }
  }
}
</script>
